<template>
  <Modal v-if="showConfirmationModal" @close="closeModal()">
    <div class="p-modal__content__header">{{ $t('labels.warning') }}</div>
    <div class="confirmation__body p-modal__content__body">
      <p>{{ $t('pages.CompaniesLocationStore.connectionWithGmb.warning1') }}</p>
      <p>{{ $t('pages.CompaniesLocationStore.connectionWithGmb.warning2') }}</p>
      <p>{{ $t('messages.reallySet') }}</p>
    </div>
    <div class="p-modal__content__footer">
      <div class="c-button c-button--center">
        <button class="c-button__item c-button__item--outline-cancel" @click="closeModal()">{{ $t('labels.cancel') }}</button>
        <button class="c-button__item c-button__item--primary" @click="onSubmit()">{{ $t('labels.save') }}</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../Modal.vue'

export default {
  name: 'ConfirmationModal',
  components: {
    Modal,
  },
  props: {
    showConfirmationModal: Boolean,
  },
  emits: ['on-submit', 'close-modal'],
  methods: {
    onSubmit() {
      this.$emit('on-submit')
    },
    closeModal() {
      this.$emit('close-modal')
    },
  }
}
</script>

<style lang="scss" scoped>

.confirmation__body {
  height: auto;
}
</style>